module.exports = __WEBPACK_EXTERNAL_MODULE_5__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/Rx"
// module id = 5
// module chunks = 0